import { render, staticRenderFns } from "./WizardDisplay.vue?vue&type=template&id=a267b472&scoped=true"
import script from "./WizardDisplay.vue?vue&type=script&lang=ts"
export * from "./WizardDisplay.vue?vue&type=script&lang=ts"
import style0 from "./WizardDisplay.vue?vue&type=style&index=0&id=a267b472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a267b472",
  null
  
)

export default component.exports